import React from 'react';
import T from 'prop-types';
import { findIndex } from 'lodash-es';

const values = [
  {
    color: '#E33963',
    name: 'Slowing',
  },
  {
    color: '#F7ABB7',
    name: 'Down',
  },
  {
    color: '#AFB8C9',
    name: 'Flat',
  },
  {
    color: '#A1CDF7',
    name: 'Up',
  },
  {
    color: '#3E8EDE',
    name: 'Growing',
  },
];
const names = values.map(({ name }) => name);
const segmentDeg = 36;

const Gauge = ({ value }) => {
  const currentSegmentIndex = findIndex(values, obj => obj.name === value);
  const currentSegment = values[currentSegmentIndex];
  const segmentStart = currentSegmentIndex * segmentDeg;
  const segmentEnd = segmentStart + segmentDeg;
  const gradientValue = `from -90deg, #EDF0F5 ${segmentStart}deg, ${currentSegment.color} ${segmentStart}deg, ${currentSegment.color} ${segmentEnd}deg, #EDF0F5 ${segmentEnd}deg`;

  return (
    <div className="gauge-widget">
      <div className="gauge-wrapper">
        <div className="half-gauge-gray" style={{ backgroundImage: `conic-gradient(${gradientValue})` }} />
        <svg style={{ rotate: `${segmentStart + (segmentDeg / 2)}deg` }} xmlns="http://www.w3.org/2000/svg" width="15" height="81" viewBox="0 0 15 81" fill="none">
          <path d="M6.36122 1.3326C6.45413 0.0994418 8.26266 0.0994494 8.35557 1.33261L14.3527 80.9313C14.3565 80.9813 14.3565 81.0315 14.3527 81.0815L8.35557 160.68C8.26266 161.913 6.45413 161.913 6.36122 160.68L0.364059 81.0815C0.36029 81.0315 0.360291 80.9813 0.364059 80.9312L6.36122 1.3326Z" fill="#363D54" />
        </svg>
        {names.map(name => <div key={name} className={`names name-${name}`}>{name}</div>)}
      </div>
      <h5 className="h5">{currentSegment.name}</h5>
    </div>
  );
};

Gauge.propTypes = {
  value: T.string,
};

export default Gauge;
